<template>
  <MainContent />
</template>

<script>
import MainContent from '@/layout/MainContent.vue';

export default {
  name: "App",
  components: {
    MainContent,
  },
};
</script>

<style lang="scss" src="@/assets/scss/main.scss"></style>